<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="pb-2 sm:col-span-2">
            <h3
                :class="[
                    'text-base font-bold text-gray-700',
                    {
                        required: isRequiredNaturalComplianceProfileAttribute(
                            'investment_targets',
                            'investment_objectives'
                        ),
                    },
                ]">
                {{ $t('investment_targets.investment_objectives') }}
            </h3>
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="account.compliance_profiles.esac.investment_targets.investment_objectives.security_coverage"
                name="investment_targets.investment_objectives.security_coverage"
                :label="$t('investment_targets.security_coverage')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="account.compliance_profiles.esac.investment_targets.investment_objectives.retention_of_assets"
                name="investment_targets.investment_objectives.retention_of_assets"
                :label="$t('investment_targets.retention_of_assets')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="
                    account.compliance_profiles.esac.investment_targets.investment_objectives.distribution_of_assets
                "
                name="investment_targets.investment_objectives.distribution_of_assets"
                :label="$t('investment_targets.distribution_of_assets')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCheckbox
                v-model="account.compliance_profiles.esac.investment_targets.investment_objectives.capital_gain"
                name="investment_targets.investment_objectives.capital_gain"
                :label="$t('investment_targets.capital_gain')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputTextActivatable
                v-model="
                    account.compliance_profiles.esac.investment_targets.investment_objectives.other_investment_target
                "
                name="investment_targets.investment_objectives.other_investment_target"
                label="Other:"></BaseInputTextActivatable>
        </div>
    </div>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-3 sm:grid-cols-2">
        <div class="flex items-end sm:col-span-1">
            <div class="w-full">
                <BaseInputSelect
                    v-model="account.compliance_profiles.esac.investment_targets.investment_horizon"
                    name="investment_targets.investment_horizon"
                    :required="isRequiredNaturalComplianceProfileAttribute('investment_targets', 'investment_horizon')"
                    :label="$t('investment_targets.investment_horizon')"
                    :hint="$t('account_settings.investment_targets_subtitle')"
                    :options="investmentHorizonOptions" />
            </div>
        </div>
        <div class="sm:col-span-1">
            <BaseInputSelect
                v-model="account.compliance_profiles.esac.investment_targets.investment_frequency"
                name="investment_targets.investment_frequency"
                :required="isRequiredNaturalComplianceProfileAttribute('investment_targets', 'investment_frequency')"
                :label="$t('investment_targets.investment_frequency')"
                :options="investmentFrequencyOptions" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { InvestmentFrequencyOption, InvestmentHorizonOption } from '../../../../typings'
import BaseInputCheckbox from '../../../base/BaseInputCheckbox.vue'
import BaseInputSelect from '../../../base/BaseInputSelect.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'

import {
    getNaturalWidgetFormValidationRules,
    initializeNaturalWidgetForm,
    isRequiredNaturalComplianceProfileAttribute,
} from './forms'
import BaseInputTextActivatable from '../../../base/BaseInputTextActivatable.vue'
import { enumToSelectOptions } from '../../../../utilities/helpers'

const { naturalProfile: account } = usePersonalAccountDataState()
const investmentFrequencyOptions = enumToSelectOptions(InvestmentFrequencyOption, 'investment_frequency')

const investmentHorizonOptions = enumToSelectOptions(InvestmentHorizonOption, 'investment_horizon')

initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('investment_targets'))
</script>
